import * as request from "./masterDataUserCrud";
import {
  superAdminMasterDataUserSlice,
  callTypes
} from "./masterDataUserSlice";

import { actions as auth } from "../../../Auth/_redux/authRedux";
import { toastOption } from "../../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = superAdminMasterDataUserSlice;

export const fetchUsersBySuperAdmin = payload => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return request
    .findUsers(payload)
    .then(({ data }) => {
      const { count, rows } = data.data;
      dispatch(actions.masterDataUsersFetched({ count, rows }));
      return data;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchUserBySuperAdmin = id => async dispatch => {
  if (!id) {
    return dispatch(actions.reloadData());
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return request
    .findSuperAdminUserById(id)
    .then(({ data }) => {
      const { data: user } = data;

      if(!user.regional) {
        user.regional = {
          id: null,
          name: null
        }
      }

      let modifiedData = { ...user, regional_name: user.regional.name };

      dispatch(actions.masterDataUserFetched(modifiedData));
    })
    .catch(error => {
      console.log(error, "error");
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const reloadFetchUser = () => dispatch => {
  dispatch(actions.reloadData());
};

export const updateUserSuperAdmin = (id, user) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return request
    .updateSuperAdminUser(id, user)
    .then(response => {
      dispatch(actions.reloadData());
      return response.data;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const deleteUserSuperAdmin = (id, user) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return request
    .updateSuperAdminUser(id, user)
    .then(response => {
      dispatch(actions.reloadData());
      return response.data;
    })
    .catch(error => {
      console.log(error, "error");
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
}
